var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path9, _rect0, _path0, _path1, _path10, _path11, _rect1, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 581.99224,
    height: 693.11084,
    viewBox: "0 0 581.99224 693.11084",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M777.2608,445.527q15.22494,2.04,30.29,5.13v1.85q-14.97-3.045-30.29-5.06a451.07443,451.07443,0,0,0-58.44-3.87h-.66a437.55757,437.55757,0,0,0-181.93,39.77q-17.745,8.09994-34.69,17.71a450.56907,450.56907,0,0,0-101.59,78.68,445.02789,445.02789,0,0,0-54.14,68.22q-3,4.635-5.87,9.36a438.87647,438.87647,0,0,0-21.14,38.97,432.50873,432.50873,0,0,0-31.27,89.32c-.17.66-.32,1.32995-.47,2-.04.18994-.09.38995-.13.57995l-1.95-.44c.01-.05.02-.09.03-.13995.15-.67005.3-1.33.46-2a438.81469,438.81469,0,0,1,32.08-91.47v-.01a442.45563,442.45563,0,0,1,22.39-41.02q2.88-4.68009,5.87-9.29a447.78406,447.78406,0,0,1,53.99-67.68,442.59965,442.59965,0,0,1,39.13-35.78l.01-.01a446.23056,446.23056,0,0,1,62.6-42.42q13.995-7.86,28.39-14.57995a442.5065,442.5065,0,0,1,189.17-41.78A446.954,446.954,0,0,1,777.2608,445.527Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300.11368,
    cy: 69.4033,
    r: 54.31516,
    fill: "#ff6584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.66168,775.8491c1.694,6.26184,7.49609,10.14,7.49609,10.14s3.05573-6.27435,1.36177-12.53619-7.49609-10.14-7.49609-10.14S330.96774,769.58732,332.66168,775.8491Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.15081,774.5034c4.64821,4.52484,5.216,11.48059,5.216,11.48059s-6.96851-.3805-11.61672-4.90534-5.216-11.48059-5.216-11.48059S330.50259,769.97856,335.15081,774.5034Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#f59e0b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M461.66168,775.8491c1.69394,6.26184,7.49609,10.14,7.49609,10.14s3.05573-6.27435,1.36176-12.53619-7.4961-10.14-7.4961-10.14S459.96774,769.58732,461.66168,775.8491Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M464.15081,774.5034c4.64823,4.52484,5.216,11.48059,5.216,11.48059s-6.96851-.3805-11.61673-4.90534-5.216-11.48059-5.216-11.48059S459.50259,769.97856,464.15081,774.5034Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#f59e0b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M807.55078,226.70218V291.367l-30.29,20.42-44.5,29.98-49.45,33.33-77.6-38.8-98.05-49.02-20.42-10.21-20.42-16.34,63.05-56.30005,18.10863-16.16788a116.71667,116.71667,0,0,1,77.73374-29.65206h113.7425A68.09512,68.09512,0,0,1,807.55078,226.70218Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M777.53076,260.437l30.02-32.63c52.49023,193.62451,56.78033,380.8139,0,559.85h-38.09l-2.05-2.05-53.1-53.09-30.82-30.82.81-5.94,2.8-20.43,6.15-44.93,6.71-49.02,6.71-49.01,6.71-49.02,5.44-39.77.28-2.01.99-7.24,6.71-49.02,5.96-43.54.75-5.47,4.94-36.08,2.05-14.98,36.76-24.51Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M466.81727,260.72464l310.44313,0V787.66105l-310.44313,0C432.92023,594.856,424.39945,414.897,466.81727,260.72464Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 320.76742,
    y: 563.91435,
    width: 57.18689,
    height: 128.67053,
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 234.98709,
    y: 486.30357,
    width: 236.91718,
    height: 49.01733,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 388.9871,
    y: 603.42172,
    width: 101.01291,
    height: 20.89922,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 208.9871,
    y: 603.42172,
    width: 101.01291,
    height: 20.89922,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 234.98709,
    y: 388.26887,
    width: 236.91718,
    height: 49.01733,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 234.98709,
    y: 290.2342,
    width: 236.91718,
    height: 49.01733,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 234.98709,
    y: 192.1995,
    width: 236.91718,
    height: 49.01733,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 690.53089,
    width: 541,
    height: 2,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 73.38522,
    y: 459.61479,
    width: 5.87477,
    height: 232.05347,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M400.02826,584.26355c.374,81.14331-56.71465,147.18748-56.71465,147.18748s-57.695-65.51514-58.06894-146.65845,56.71465-147.18751,56.71465-147.18751C348.03445,416.1062,413.03674,455.7619,400.02826,584.26355Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#f59e0b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.02826,584.26355c.374,81.14331-56.71465,147.18748-56.71465,147.18748s-57.695-65.51514-58.06894-146.65845,56.71465-147.18751,56.71465-147.18751C348.03445,416.1062,413.03674,455.7619,400.02826,584.26355Z",
    transform: "translate(-266.55078 -95.07617)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    y: 459.61084,
    width: 2.89001,
    height: 232.06,
    fill: "#3f3d56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M323.66076,584.267c68.84412,17.83252-5.14271,60.15967-18.9,84.8v.01a279.37215,279.37215,0,0,1-35.32,59.32c-1.59,2-2.5,3.05-2.5,3.05l-.39-.45V438.737a275.50474,275.50474,0,0,1,37.59,61.24005v.01C314.78076,523.807,293.26358,576.39331,323.66076,584.267Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#f59e0b"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M407.72076,374.517s-37.36-.33-83.63995-.12c-22.24.1-42.49.31-57.53.51v-25.87c16.18-12.39,37.52-22.26,57.37-11.08C362.92077,359.937,407.72076,374.517,407.72076,374.517Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M492.0856,136.39649c-46.27674.21329-83.94416.897-83.94416.897s44.77366-59.30728,83.77625-37.33436,83.80664,36.562,83.80664,36.562S538.36233,136.18321,492.0856,136.39649Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#f2f2f2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M620.42077,156.687l124.18752-6.07231A68.09512,68.09512,0,0,1,815.4869,210.053l15.06388,118.664-52.91-68.22-.11-.06-158.33-82.12-3.14216-1.62936c-9.61071-4.9836-6.45095-19.47142,4.36209-20.00064Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#3f3d56"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 315.9871,
    y: 102.42172,
    width: 101.01291,
    height: 20.89922,
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M644.55078,645.717h-47q-49.10235-191.68506,0-376h47C674.47094,397.20978,675.54406,522.62055,644.55078,645.717Z",
    transform: "translate(-266.55078 -95.07617)",
    fill: "#f2f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartments);
export default __webpack_public_path__ + "static/media/departments.5c1e73bbbc6c0b7bcdf32cbeec3c303b.svg";
export { ForwardRef as ReactComponent };